import { Directive, ElementRef } from "@angular/core";
import { BasePathService } from "../services/base-path.service";
import * as i0 from "@angular/core";
import * as i1 from "../services/base-path.service";
export class CorrectLinksDirective {
    constructor(el, basePathService) {
        if (el.nativeElement?.href) {
            const url = new URL(el.nativeElement.href);
            url.pathname = basePathService.basePath$.value + url.pathname;
            el.nativeElement.href = url;
        }
    }
}
CorrectLinksDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: CorrectLinksDirective, deps: [{ token: i0.ElementRef }, { token: i1.BasePathService }], target: i0.ɵɵFactoryTarget.Directive });
CorrectLinksDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.2.5", type: CorrectLinksDirective, selector: "a", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: CorrectLinksDirective, decorators: [{
            type: Directive,
            args: [{ selector: "a" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1.BasePathService }]; } });
